import _ from 'lodash';
import type { DivisionsQuery, DivisionsQueryVariables } from '@/shared/api/__generated__/graphql';
import createClient from '../apolloClient';
import DIVISIONS_QUERY from '../queries/divisions';

/**
 * Retrieves the states or provinces of one country for address forms. Runs the divisions query with the country code on a cache-enabled client, throws the first GraphQL error when divisions are missing, and hands back the whole query result.
 *
 * @param countryCode - ISO code of the country whose divisions are needed.
 * @returns Full Apollo query result holding the divisions.
 */
const fetchDivisions = async (countryCode: string) => {
  const client = createClient({ isUsingCache: true });
  const divisionsResult = await client.query<DivisionsQuery, DivisionsQueryVariables>({
    query: DIVISIONS_QUERY,
    variables: {
      countryCode,
    },
  });
  const { data, errors } = divisionsResult;
  const { divisions } = data;
  if (_.isNil(divisions) && errors?.length) {
    throw new Error(errors[0].message);
  }
  return divisionsResult;
};

export default fetchDivisions;
